import { ReactElement, useContext } from "react"

import {
    NON_SYS_ADMIN_EVAC_STEPS,
    SYS_ADMIN_LCT_STEPS,
} from "../../../../../constants/lct/evac/deviceForm"
import AppStepper from "../../../../dataDisplay/stepper/appStepper"
import { CreateEVACDeviceContext } from "../providers/baseProviders/createEVACDeviceProvider"

/** AppStepper for EVAC device creation
 */
const CreateEvacDeviceProgressStepper = (): ReactElement => {
    const { currentIndex, canEditManufacturer } = useContext(
        CreateEVACDeviceContext
    )

    const steps = canEditManufacturer
        ? [...SYS_ADMIN_LCT_STEPS, ...NON_SYS_ADMIN_EVAC_STEPS]
        : NON_SYS_ADMIN_EVAC_STEPS

    return <AppStepper stepLabels={steps} currentStepIndex={currentIndex} />
}

export default CreateEvacDeviceProgressStepper
